module.exports = __webpack_public_path__ + "img/3_Left2.10433a46.png";